<div class="aligner-start header-data">
  <div
    class="active-border-header"
    *ngIf="params.activeHeaderColumn && params.activeHeaderColumn?.field_name === params.dataColumn.field_name"
  ></div>
  <div class="icon-wrap">
    <y42-column-type-icon [type]="params.dataColumn.data_type"></y42-column-type-icon>
    <fa-icon class="fs-09 resize-icon text-gray-600" [icon]="['fal', 'grip-lines-vertical']"></fa-icon>
  </div>
  <div
    class="customHeaderLabel truncate"
    [matTooltip]="params.dataColumn.description"
    (click)="onSortRequested($event)"
    [intercomTarget]="'01-header-29745' + params.dataColumn.field_name"
  >
    <ng-container *ngIf="state.sortedIcon">
      <fa-icon class="fs-07" *ngIf="params.enableSorting && state.sorted" [icon]="state.sortedIcon"> </fa-icon>&nbsp;
    </ng-container>
    {{ params.dataColumn.field_name }}
  </div>
  <button
    #customHeaderMenuButton
    mat-icon-button
    class="small-icon-button absolute header-data-button"
    (click)="onMenuClick()"
    [intercomTarget]="'01-header-29741' + params.dataColumn.field_name"
  >
    <fa-icon class="fs-07" [icon]="['fal', 'bars']"></fa-icon>
  </button>
  <button
    mat-icon-button
    class="small-icon-button absolute header-data-button-calculate"
    matTooltip="Reset Filter"
    (click)="resetFilter()"
    [intercomTarget]="'01-header-29742' + params.dataColumn.field_name"
    *ngIf="state.filterActive"
  >
    <fa-icon class="fs-06 text-blue-800" [icon]="['fal', 'filter']"></fa-icon>
  </button>
  <button
    matTooltip="Calculate Descriptive Statistics"
    mat-icon-button
    *ngIf="
      params.showAnalyzeColumnBtn &&
      !(params.activeHeaderColumn && params.activeHeaderColumn?.field_name === params.dataColumn.field_name)
    "
    class="small-icon-button column-description-info _analyze absolute"
    (click)="analyzeColumn()"
    [intercomTarget]="'01-header-29747' + params.dataColumn.field_name"
  >
    <fa-icon class="text-blue-800 fs-06" [icon]="['fal', 'analytics']"></fa-icon>
  </button>
</div>
<div class="header-graph" *ngIf="!params.hideHeaderGraph">
  <mat-spinner [color]="'primary'" class="mt-1" *ngIf="params.loading" [diameter]="18"> </mat-spinner>
  <div class="header-bar" *ngIf="params.distinct > 0 && !params.loading">
    {{ params.distinct | formatValueConversion }} value{{ params.distinct > 1 ? 's' : '' }}
  </div>
  <div *ngIf="params.distinct <= 0 && !params.loading">0 Values</div>
  <div class="header-graph-body flex mt-0" *ngIf="!params.loading">
    <button
      class="header-graph-bar"
      mat-button
      *ngFor="let dist of state.sortedDistributionsDesc; trackBy: trackByValue"
      (click)="setFilter(dist.value)"
      [intercomTarget]="'01-header-29749' + dist.value"
      [class.null-bar]="dist.value === null"
      [ngClass]="dist.isActive ? 'active-bar' : ''"
      [matTooltip]="dist.tooltip"
      [ngStyle]="dist.style"
    ></button>
    <div
      class="header-graph-body-format"
      [matTooltip]="(params.distinct - 10 | formatValueConversion) + ' more values'"
      *ngIf="params.distinct > 10"
    >
      .
    </div>
  </div>
</div>
